@if (!productKind() || descriptions().length === 0) {
	<div class="alert alert-warning text-center">
		Brak dostępnych opisów dla danego produktu lub wybierz typ produktu by wyświetlić dostępne opisy!
	</div>
} @else {
	<fieldset>
		<button [disabled]="editable()" (click)="copyDescriptions()" type="button" class="btn btn-primary my-2">
			Kopiuj {{ use() === OfferTransportKind.COACH ? 'opisy z samolotów' : 'opisy z autokarów' }}
		</button>

		@for (item of descriptions(); track item.descriptionHeader?.id) {
			<div>
				<h6>
					{{ item.descriptionHeaderTitle }}
					@if (item.comment) {
						<i class="fa fa-circle-info" [matTooltip]="item.comment | convertComment"></i>
					}
					@if (item.isRequired) {
						<small class="ms-2 text-danger">* wymagane do opublikowania produktu</small>
					}
				</h6>
				<div class="mb-4">
					<app-editor
						[(value)]="item.description"
						(valueChange)="updateDescription(item)"
						[disabled]="editable()"
					></app-editor>
				</div>
			</div>
		}
	</fieldset>
}
